import { ReactNode } from 'react';
import { Layout } from '@/common/components/layout/Layout';
import { NavMenu } from '@/features/navigation/components/nav-menu/NavMenu';
import { UserMenu } from '@/features/navigation/components/user-menu/UserMenu';
import { RouterBreadcrumbs } from '@/features/navigation/components/router-breadcrumbs/RouterBreadcrumbs.tsx';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ErrorBoundary } from '@/common/components/error-boundary/ErrorBoundary.tsx';
import logo from '@/assets/Deso-Logo-White-RGB.svg';
import styled from '@emotion/styled';
import { Link } from '@tanstack/react-router';

const StyledLogo = styled('img')`
  max-width: 100%;
  height: 100%;
`;

export interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  return (
    <Layout
      topBarLeft={
        <Link to="/">
          <Box height={{ xs: 32, sm: 42 }}>
            <StyledLogo src={logo} alt="DESO logo" />
          </Box>
        </Link>
      }
      topBarRight={<UserMenu />}
      sidebar={<NavMenu />}
    >
      <Stack height="100%">
        <ErrorBoundary>
          <RouterBreadcrumbs />
          <Box sx={{ p: { xs: 2, sm: 3 }, pb: { xs: 12, sm: 3 }, flex: 1 }}>{children}</Box>
        </ErrorBoundary>
      </Stack>
    </Layout>
  );
}
